// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__19FPY","unreadBadge":"styles_unreadBadge__iRv1-","modalContent":"styles_modalContent__P15qi","modal":"styles_modal__10HAr"};